export default "__VITE_ASSET__DtR$9g$6__"